import * as Yup from 'yup';
//

// ---------------------------------------------------------------------- //

Yup.setLocale({
  mixed: {
    default: 'Campo obrigatório',
    required: 'Campo obrigatório',
    oneOf: 'Campo obrigatório',
    notType: 'Valor inválido',
    defined: 'Campo obrigatório',
    notOneOf: 'Valor inválido',
  },
  number: {
    min: `Mínimo de \${min}`,
    max: `Máximo de \${max}`,
  },
  string: {
    min: `Mínimo de \${min} caracteres`,
    max: `Máximo de \${max} caracteres`,
    matches: 'Valor inválido',
    uuid: 'Campo obrigatório',
  },
  array: {
    min: `Informe no mínimo \${min}`,
    max: `Informe no máximo \${max}`,
  },
});

// ---------------------------------------------------------------------- //

const string = () => Yup.string().required().trim();
const number = () => Yup.number().required();

const string_nullable = () =>
  string()
    .transform((v, o) => (o === '' ? null : v) as string)
    .nullable();


//

const YupC = {
  string,
  number,
  string_nullable,
  //
};

// ---------------------------------------------------------------------- //

export { Yup, YupC };